import {ComponentTypes} from '@dazn/lp-web/src/constants/componentTypes.constants';
import {IButton, IStandardRail} from '@dazn/lp-web/src/types';
import {railProxy} from '@dazn/lp-web/src/utils';
import {buttonProxy} from '@dazn/lp-web/src/proxies/button.proxy';

export function showsRailProxy(component: any, showsRail?: any): IStandardRail {
    if (showsRail) {
        const rail = showsRail
            ? railProxy(showsRail, ComponentTypes.SHOWS_RAIL)
            : null;

        return {
            ...component,
            tiles: rail?.tiles ?? []
        };
    }

    const componentType = component?.fields?.componentType;
    const railId = component?.fields?.railId;
    const title = component?.fields?.title;
    const description = component?.fields?.description;

    let button = {} as IButton;
    component?.fields?.entries?.forEach(({fields, sys}: any) => {
        if (sys?.contentType?.sys?.id === 'LPButton') {
            button = buttonProxy(fields);
        }
    });

    return {
        componentType,
        railId,
        button,
        railType: ComponentTypes.SHOWS_RAIL,
        title,
        description,
        tiles: [],
        railParams: component?.fields?.railParams
    };
}
